const hi = {
  'Get started': 'शुरू करें',
  'Your premium travel experience.': 'आपका प्रीमियम यात्रा अनुभव।',
  'Location access': 'लोकेशन एक्सेस',
  'We need your location to identify your hotel and find the nearest pickup point.': 'आपका होटल पहचानने और निकटतम पिकअप स्थान खोजने के लिए हमें आपकी लोकेशन चाहिए।',
  'Allow access': 'एक्सेस दें',
  'Finding nearby hotels...': 'आस-पास के होटल खोजे जा रहे हैं...',
  'Retry': 'फिर से कोशिश करें',
  'Pick on map': 'मैप पर चुनें',
  'Search hotels': 'होटल खोजें',
  'No vehicles available for this trip': 'इस यात्रा के लिए कोई वाहन उपलब्ध नहीं है',
  'Unable to load vehicles. Please try again.': 'वाहन लोड नहीं हो सके। कृपया फिर कोशिश करें।',
  'Select a hotel on the map': 'मैप पर एक होटल चुनें',
  'Staying at': 'आप ठहरे हैं',
  'Edit': 'संपादित करें',
  'Pickup point': 'पिकअप स्थान',
  'Hotel Porch': 'होटल पोर्च',
  'Confirm Location': 'स्थान की पुष्टि करें',
  'No hotel data is available right now.': 'अभी होटल की जानकारी उपलब्ध नहीं है।',
  'No hotels were found near this location. You can try again or choose your hotel on the map.': 'इस स्थान के पास कोई होटल नहीं मिला। फिर कोशिश करें या मैप पर होटल चुनें।',
  'We could not load nearby hotels. Check your connection and tap Retry.': 'आस-पास के होटल लोड नहीं हो सके। कनेक्शन जाँचें और फिर कोशिश करें।',
  'We need your location before nearby hotels can be shown.': 'आस-पास के होटल दिखाने से पहले हमें आपकी लोकेशन चाहिए।',
  'Selected Address': 'चुना हुआ पता',
  'Book Premium Rides for now or later.': 'अभी या बाद के लिए प्रीमियम राइड बुक करें।',
  'Hi {name}!': 'नमस्ते {name}!',
  'Where would you like to go today?': 'आज आप कहाँ जाना चाहेंगे?',
  'Search New Delhi...': 'नई दिल्ली खोजें...',
  'No results found': 'कोई परिणाम नहीं मिला',
  'Loading categories...': 'श्रेणियाँ लोड हो रही हैं...',
  'Loading locations...': 'स्थान लोड हो रहे हैं...',
  'No locations available. Please select a category.': 'कोई स्थान उपलब्ध नहीं है। कृपया एक श्रेणी चुनें।',
  'Home': 'होम',
  'Ride': 'राइड',
  'Contact': 'संपर्क',
  'Profile': 'प्रोफ़ाइल',
  'All': 'सभी',
  'more': 'और',
  'less': 'कम',
  'List view': 'सूची दृश्य',
  'Grid view': 'ग्रिड दृश्य',
  'Payment Methods': 'भुगतान के तरीके',
  'Settings': 'सेटिंग्स',
  'Logout': 'लॉग आउट',
  'Close': 'बंद करें',
  'Install Moviq': 'Moviq इंस्टॉल करें',
  'Add Moviq to your home screen for quicker booking.': 'तेज़ बुकिंग के लिए Moviq को होम स्क्रीन पर जोड़ें।',
  'Install': 'इंस्टॉल',
  'Not now': 'अभी नहीं',
  'On iPhone, tap Share, then Add to Home Screen.': 'iPhone पर Share दबाएँ, फिर Add to Home Screen चुनें।',
  'Got it': 'समझ गया',
  'Open the browser menu and tap Install app.': 'ब्राउज़र मेनू खोलें और Install app दबाएँ।',
  'Follow these steps in Safari:': 'Safari में ये चरण अपनाएँ:',
  'Open this page in Safari, then follow these steps:': 'यह पेज Safari में खोलें, फिर ये चरण अपनाएँ:',
  'Tap the Share button in Safari.': 'Safari में Share बटन दबाएँ।',
  'Tap Add to Home Screen.': 'Add to Home Screen दबाएँ।',
  'Tap Add.': 'Add दबाएँ।',
  'Are you sure you want to logout?': 'क्या आप वाकई लॉग आउट करना चाहते हैं?',
  'Room {room} • {hotel}': 'कमरा {room} • {hotel}',
  'Edit Profile': 'प्रोफ़ाइल संपादित करें',
  'Save': 'सहेजें',
  'Back': 'वापस',
  'Full Name': 'पूरा नाम',
  'Email Address': 'ईमेल पता',
  'Phone Number': 'फ़ोन नंबर',
  'Enter your name': 'अपना नाम दर्ज करें',
  'Enter your email': 'अपना ईमेल दर्ज करें',
  'Enter your phone': 'अपना फ़ोन दर्ज करें',
  'Profile updated successfully!': 'प्रोफ़ाइल अपडेट हो गई!',
  'Profile image updated successfully!': 'प्रोफ़ाइल फ़ोटो अपडेट हो गई!',
  'App preferences & legal': 'ऐप प्राथमिकताएँ और कानूनी',
  'Go back': 'वापस जाएँ',
  'Notifications': 'सूचनाएँ',
  'Location Access': 'लोकेशन एक्सेस',
  'Language': 'भाषा',
  'Dark Mode': 'डार्क मोड',
  'Privacy Policy': 'गोपनीयता नीति',
  'Terms of Service': 'सेवा की शर्तें',
  'About Moviq': 'Moviq के बारे में',
  'Made with ❤ for Travellers': 'यात्रियों के लिए ❤ से बनाया गया',
  'English': 'English',
  'Hindi': 'हिंदी',
  'Chinese': '中文',
  'Spanish': 'Español',
  'Contact Us': 'हमसे संपर्क करें',
  'moviq Support': 'moviq सहायता',
  'Priority Support': 'प्राथमिक सहायता',
  'FAQs': 'अक्सर पूछे जाने वाले प्रश्न',
  'Answer': 'उत्तर',
  'Questions': 'प्रश्न',
  'History': 'इतिहास',
  'No matching questions.': 'कोई मेल खाता प्रश्न नहीं।',
  'No FAQs yet.': 'अभी कोई प्रश्न नहीं।',
  'No answer is available for this question.': 'इस प्रश्न का उत्तर उपलब्ध नहीं है।',
  'CALL SUPPORT': 'सहायता को कॉल करें',
  'Previous FAQs': 'पिछले प्रश्न',
  'Loading...': 'लोड हो रहा है...',
  'Sign in to see your FAQ history.': 'अपना प्रश्न इतिहास देखने के लिए साइन इन करें।',
  'No previous FAQs': 'कोई पिछला प्रश्न नहीं',
  'Open': 'खुला',
  'In progress': 'प्रगति पर',
  'Closed': 'बंद',
  'Questions and your previous help answers.': 'प्रश्न और आपके पिछले सहायता उत्तर।',
  'Search questions': 'प्रश्न खोजें',
  'Loading questions...': 'प्रश्न लोड हो रहे हैं...',
  'Loading history...': 'इतिहास लोड हो रहा है...',
  'Loading answer...': 'उत्तर लोड हो रहा है...',
  'Back to FAQs': 'प्रश्नों पर वापस',
  'Sign in to save this in your help history.': 'इसे सहायता इतिहास में सहेजने के लिए साइन इन करें।',
  'Today': 'आज',
  'Yesterday': 'कल',
  'This week': 'इस सप्ताह',
  'Day': 'दिन',
  'Month': 'महीना',
  'Year': 'वर्ष',
  'No FAQs today': 'आज कोई प्रश्न नहीं',
  'No FAQs yesterday': 'कल कोई प्रश्न नहीं',
  'No FAQs this week': 'इस सप्ताह कोई प्रश्न नहीं',
  'No FAQs this day': 'इस दिन कोई प्रश्न नहीं',
  'No FAQs this month': 'इस महीने कोई प्रश्न नहीं',
  'No FAQs': 'कोई प्रश्न नहीं',
  'Rides': 'राइड्स',
  'Review your journey so far.': 'अब तक की अपनी यात्रा देखें।',
  'Loading rides...': 'राइड्स लोड हो रही हैं...',
  'No rides found': 'कोई राइड नहीं मिली',
  'Waiting for payment': 'भुगतान की प्रतीक्षा',
  'Upcoming': 'आगामी',
  'Past rides': 'पिछली राइड्स',
  'Cancelled': 'रद्द',
  'Vendor will be assigned': 'वेंडर असाइन किया जाएगा',
  'Waiting for vendor': 'वेंडर की प्रतीक्षा',
  'Waiting for car': 'कार की प्रतीक्षा',
  'Car assigned': 'कार असाइन हो गई',
  'Vendor assigned': 'वेंडर असाइन हो गया',
  'Requested vehicle': 'अनुरोधित वाहन',
  'Requested: {name}': 'अनुरोध: {name}',
  'Pay now': 'अभी भुगतान करें',
  'No rides waiting for payment': 'भुगतान की प्रतीक्षा में कोई राइड नहीं',
  'No upcoming rides': 'कोई आगामी राइड नहीं',
  'No past rides': 'कोई पिछली राइड नहीं',
  'No cancelled rides': 'कोई रद्द राइड नहीं',
  'Your ride history will appear here': 'आपकी राइड्स यहाँ दिखेंगी',
  'Driver phone:': 'ड्राइवर फ़ोन:',
  'Total fare': 'कुल किराया',
  'Confirm Trip': 'यात्रा की पुष्टि करें',
  'PICKUP POINT': 'पिकअप स्थान',
  'DROP DESTINATION': 'ड्रॉप स्थान',
  'DROP OFF': 'ड्रॉप ऑफ',
  'GUESTS': 'मेहमान',
  'BAGS': 'बैग',
  'DATE': 'तारीख',
  'TIME': 'समय',
  'Select your ride': 'अपनी राइड चुनें',
  'Choose from our premium fleet.': 'हमारे प्रीमियम बेड़े में से चुनें।',
  'PICK UP': 'पिकअप',
  'Loading vehicles...': 'वाहन लोड हो रहे हैं...',
  'Recommended': 'सुझाया गया',
  'Booking summary': 'बुकिंग सारांश',
  'Booking Summary': 'बुकिंग सारांश',
  'Review your journey and fare.': 'अपनी यात्रा और किराया देखें।',
  'PREMIUM SERIES': 'प्रीमियम सीरीज़',
  'Base fare': 'आधार किराया',
  'GST (5%)': 'जीएसटी (5%)',
  'Service fee': 'सेवा शुल्क',
  'Grand total': 'कुल योग',
  'Online Payment': 'ऑनलाइन भुगतान',
  'UPI, Wallet, Netbanking': 'यूपीआई, वॉलेट, नेट बैंकिंग',
  'Cash to driver': 'ड्राइवर को नकद',
  'Cash': 'नकद',
  'Pay after trip ends': 'यात्रा समाप्त होने के बाद भुगतान करें',
  'Pay directly to driver after trip ends.': 'यात्रा समाप्त होने के बाद सीधे ड्राइवर को भुगतान करें।',
  'Payment method': 'भुगतान का तरीका',
  'Wallet': 'वॉलेट',
  'Manage payment methods': 'भुगतान के तरीके प्रबंधित करें',
  'CARD HOLDER': 'कार्ड धारक',
  'EXPIRES': 'समाप्ति',
  'Add Payment Method': 'भुगतान का तरीका जोड़ें',
  'Processing...': 'प्रसंस्करण...',
  'Delete card': 'कार्ड हटाएँ',
  'UPI': 'यूपीआई',
  'Guest verification': 'अतिथि सत्यापन',
  'Mobile number': 'मोबाइल नंबर',
  'Confirm OTP': 'ओटीपी की पुष्टि करें',
  'OTP is not correct': 'ओटीपी सही नहीं है',
  'OTP has expired. Please request a new one.': 'ओटीपी की समय सीमा समाप्त हो गई है। नया ओटीपी माँगें।',
  'This OTP has already been used. Please request a new one.': 'यह ओटीपी पहले ही उपयोग हो चुका है। नया ओटीपी माँगें।',
  'Please wait before requesting another OTP.': 'नया ओटीपी माँगने से पहले प्रतीक्षा करें।',
  'Unable to resend OTP. Please try again.': 'ओटीपी फिर से नहीं भेजा जा सका। कृपया फिर कोशिश करें।',
  'OTP sent again.': 'ओटीपी फिर से भेज दिया गया है।',
  'Please enter the complete 6-digit OTP': 'कृपया पूरा 6 अंकों का ओटीपी दर्ज करें',
  'Please fill in your details to continue.': 'जारी रखने के लिए अपनी जानकारी भरें।',
  'This username is already taken': 'यह उपयोगकर्ता नाम पहले से लिया गया है',
  'This email is already registered': 'यह ईमेल पहले से पंजीकृत है',
  'This account is not active. Please contact support.': 'यह खाता सक्रिय नहीं है। सहायता से संपर्क करें।',
  'Mobile number is required': 'मोबाइल नंबर आवश्यक है',
  'Resend OTP': 'ओटीपी फिर भेजें',
  'Resend OTP in {time}': '{time} में ओटीपी फिर भेजें',
  'Sending...': 'भेजा जा रहा है...',
  'Verify OTP': 'ओटीपी सत्यापित करें',
  'Verifying...': 'सत्यापित किया जा रहा है...',
  'Full name': 'पूरा नाम',
  'Username': 'उपयोगकर्ता नाम',
  'Email': 'ईमेल',
  'Password': 'पासवर्ड',
  'Request Details': 'अनुरोध विवरण',
  'Request submitted successfully !': 'अनुरोध सफलतापूर्वक जमा हो गया!',
  'Finding you a driver at the earliest.': 'हम जल्द से जल्द आपके लिए ड्राइवर ढूंढ रहे हैं।',
  'Request Submitted': 'अनुरोध जमा हुआ',
  'Assigning a Driver': 'ड्राइवर असाइन किया जा रहा है',
  'Driver Assigned! Arriving in XX mins.': 'ड्राइवर असाइन हो गया! XX मिनट में पहुंचेंगे।',
  'Ride Completed!': 'राइड पूरी हुई!',
  'Cancel request': 'अनुरोध रद्द करें',
  'Cancelling...': 'रद्द हो रहा है...',
  'Expected Time': 'अपेक्षित समय',
  'Progress': 'प्रगति',
  'Current Status': 'वर्तमान स्थिति',
  'Track Driver >': 'ड्राइवर ट्रैक करें >',
  'Help / Contact Us': 'सहायता / संपर्क',
  'Cancel Request': 'अनुरोध रद्द करें',
  'Ride cancelled': 'राइड रद्द',
  'Ride completed': 'राइड पूरी हुई',
  'FINAL FARE': 'अंतिम किराया',
  'Payment Pending': 'भुगतान लंबित',
  'Charged successfully': 'भुगतान सफल',
  'Parking & Toll Charges': 'पार्किंग और टोल शुल्क',
  'Payment': 'भुगतान',
  'Amount to Pay': 'देय राशि',
  'From:': 'से:',
  'To:': 'तक:',
  'Save card for future payments': 'भविष्य के भुगतान के लिए कार्ड सहेजें',
  'Your payment is secured by Razorpay': 'आपका भुगतान Razorpay द्वारा सुरक्षित है',
  'Saved Cards': 'सहेजे गए कार्ड',
  'Manage': 'प्रबंधित करें',
  'Loading saved cards...': 'सहेजे गए कार्ड लोड हो रहे हैं...',
  'No saved cards': 'कोई सहेजा गया कार्ड नहीं',
  'Add a card to make payments faster': 'भुगतान तेज़ करने के लिए कार्ड जोड़ें',
  'Are you sure you want to delete this card?': 'क्या आप वाकई इस कार्ड को हटाना चाहते हैं?',
  'Failed to delete card': 'कार्ड हटाने में विफल',
  'Failed to add card': 'कार्ड जोड़ने में विफल',
  'Please complete guest verification first.': 'कृपया पहले अतिथि सत्यापन पूरा करें।',
  'Ride Details': 'राइड विवरण',
  'Route': 'मार्ग',
  'Pickup': 'पिकअप',
  'Drop-off': 'ड्रॉप-ऑफ',
  'Trip Details': 'यात्रा विवरण',
  'Distance': 'दूरी',
  'Fare Range': 'किराया सीमा',
  'Timeline': 'समयरेखा',
  'Created': 'बनाया गया',
  'Last Updated': 'अंतिम अपडेट',
  'Vendor Information': 'विक्रेता जानकारी',
  'Vendor Name:': 'विक्रेता का नाम:',
  'Vendor ID:': 'विक्रेता आईडी:',
  'Vehicle Information': 'वाहन जानकारी',
  'Car Number:': 'कार नंबर:',
  'Car ID:': 'कार आईडी:',
  'Driver Information': 'ड्राइवर जानकारी',
  'Driver Name:': 'ड्राइवर का नाम:',
  'Driver ID:': 'ड्राइवर आईडी:',
  'Customer Information': 'ग्राहक जानकारी',
  'Customer Name:': 'ग्राहक का नाम:',
  'Customer ID:': 'ग्राहक आईडी:',
  'Your private fleet': 'आपका निजी बेड़ा',
  'Identifying your stay...': 'आपका ठहराव पहचाना जा रहा है...',
  'Scanning your nearby hotels...': 'आस-पास के होटल देखे जा रहे हैं...',
  'Map View': 'मैप दृश्य',
  'PIN FOR THIS TRIP': 'इस यात्रा का पिन',
  'PICK-UP SPOT': 'पिकअप स्थान',
  'MESSAGE': 'संदेश',
  'CALL': 'कॉल',
  'Connecting you with a driver': 'आपको ड्राइवर से जोड़ा जा रहा है',
  'Booking Confirmed!': 'बुकिंग की पुष्टि हो गई!',
  'Connecting to chat...': 'चैट से जुड़ रहे हैं...',
  'No messages yet. Start the conversation!': 'अभी कोई संदेश नहीं। बातचीत शुरू करें!'
};

const zh = {
  'Get started': '开始使用',
  'Your premium travel experience.': '您的高端出行体验。',
  'Location access': '位置访问',
  'We need your location to identify your hotel and find the nearest pickup point.': '我们需要您的位置来识别酒店并找到最近的上车点。',
  'Allow access': '允许访问',
  'Finding nearby hotels...': '正在查找附近的酒店...',
  'Retry': '重试',
  'Pick on map': '在地图上选择',
  'Search hotels': '搜索酒店',
  'No vehicles available for this trip': '此行程暂无可用车辆',
  'Unable to load vehicles. Please try again.': '无法加载车辆，请重试。',
  'Select a hotel on the map': '请在地图上选择酒店',
  'Staying at': '您入住的是',
  'Edit': '编辑',
  'Pickup point': '上车点',
  'Hotel Porch': '酒店门口',
  'Confirm Location': '确认位置',
  'No hotel data is available right now.': '目前没有酒店信息。',
  'No hotels were found near this location. You can try again or choose your hotel on the map.': '此位置附近没有找到酒店。请重试或在地图上选择酒店。',
  'We could not load nearby hotels. Check your connection and tap Retry.': '无法加载附近的酒店。请检查网络后重试。',
  'We need your location before nearby hotels can be shown.': '需要您的位置才能显示附近的酒店。',
  'Selected Address': '已选地址',
  'Book Premium Rides for now or later.': '立即或稍后预订高端出行。',
  'Hi {name}!': '你好，{name}！',
  'Where would you like to go today?': '今天想去哪里？',
  'Search New Delhi...': '搜索新德里...',
  'No results found': '未找到结果',
  'Loading categories...': '正在加载分类...',
  'Loading locations...': '正在加载地点...',
  'No locations available. Please select a category.': '暂无地点。请选择一个分类。',
  'Home': '首页',
  'Ride': '行程',
  'Contact': '联系',
  'Profile': '个人资料',
  'All': '全部',
  'more': '更多',
  'less': '收起',
  'List view': '列表视图',
  'Grid view': '网格视图',
  'Payment Methods': '支付方式',
  'Settings': '设置',
  'Logout': '退出登录',
  'Close': '关闭',
  'Install Moviq': '安装 Moviq',
  'Add Moviq to your home screen for quicker booking.': '将 Moviq 添加到主屏幕，预订更快。',
  'Install': '安装',
  'Not now': '暂不',
  'On iPhone, tap Share, then Add to Home Screen.': '在 iPhone 上点分享，然后点“添加到主屏幕”。',
  'Got it': '知道了',
  'Open the browser menu and tap Install app.': '打开浏览器菜单，然后点“安装应用”。',
  'Follow these steps in Safari:': '请在 Safari 中按以下步骤操作：',
  'Open this page in Safari, then follow these steps:': '请先用 Safari 打开此页面，然后按以下步骤操作：',
  'Tap the Share button in Safari.': '点按 Safari 的分享按钮。',
  'Tap Add to Home Screen.': '点按“添加到主屏幕”。',
  'Tap Add.': '点按“添加”。',
  'Are you sure you want to logout?': '确定要退出登录吗？',
  'Room {room} • {hotel}': '房间 {room} • {hotel}',
  'Edit Profile': '编辑资料',
  'Save': '保存',
  'Back': '返回',
  'Full Name': '姓名',
  'Email Address': '电子邮箱',
  'Phone Number': '电话号码',
  'Enter your name': '输入您的姓名',
  'Enter your email': '输入您的邮箱',
  'Enter your phone': '输入您的电话',
  'Profile updated successfully!': '资料已更新！',
  'Profile image updated successfully!': '头像已更新！',
  'App preferences & legal': '应用偏好与法律信息',
  'Go back': '返回',
  'Notifications': '通知',
  'Location Access': '位置权限',
  'Language': '语言',
  'Dark Mode': '深色模式',
  'Privacy Policy': '隐私政策',
  'Terms of Service': '服务条款',
  'About Moviq': '关于 Moviq',
  'Made with ❤ for Travellers': '为旅行者用心 ❤ 打造',
  'English': 'English',
  'Hindi': 'हिंदी',
  'Chinese': '中文',
  'Spanish': 'Español',
  'Contact Us': '联系我们',
  'moviq Support': 'moviq 客服',
  'Priority Support': '优先支持',
  'FAQs': '常见问题',
  'Answer': '回答',
  'Questions': '问题',
  'History': '历史',
  'No matching questions.': '没有匹配的问题。',
  'No FAQs yet.': '还没有问题。',
  'No answer is available for this question.': '这个问题暂无回答。',
  'CALL SUPPORT': '致电客服',
  'Previous FAQs': '历史问题',
  'Loading...': '加载中...',
  'Sign in to see your FAQ history.': '登录后查看您的问题记录。',
  'No previous FAQs': '暂无历史问题',
  'Open': '待处理',
  'In progress': '处理中',
  'Closed': '已关闭',
  'Questions and your previous help answers.': '问题以及您之前的帮助回复。',
  'Search questions': '搜索问题',
  'Loading questions...': '正在加载问题...',
  'Loading history...': '正在加载记录...',
  'Loading answer...': '正在加载回答...',
  'Back to FAQs': '返回常见问题',
  'Sign in to save this in your help history.': '登录后可将此内容保存到帮助记录。',
  'Today': '今天',
  'Yesterday': '昨天',
  'This week': '本周',
  'Day': '日',
  'Month': '月',
  'Year': '年',
  'No FAQs today': '今天没有问题',
  'No FAQs yesterday': '昨天没有问题',
  'No FAQs this week': '本周没有问题',
  'No FAQs this day': '这一天没有问题',
  'No FAQs this month': '本月没有问题',
  'No FAQs': '没有问题',
  'Rides': '行程',
  'Review your journey so far.': '查看您到目前为止的行程。',
  'Loading rides...': '正在加载行程...',
  'No rides found': '未找到行程',
  'Waiting for payment': '等待付款',
  'Upcoming': '即将开始',
  'Past rides': '过往行程',
  'Cancelled': '已取消',
  'Vendor will be assigned': '即将分配供应商',
  'Waiting for vendor': '等待供应商',
  'Waiting for car': '等待车辆',
  'Car assigned': '已分配车辆',
  'Vendor assigned': '已分配供应商',
  'Requested vehicle': '已选车型',
  'Requested: {name}': '已选：{name}',
  'Pay now': '立即支付',
  'No rides waiting for payment': '没有待付款行程',
  'No upcoming rides': '没有即将开始的行程',
  'No past rides': '没有过往行程',
  'No cancelled rides': '没有已取消行程',
  'Your ride history will appear here': '您的行程会显示在这里',
  'Driver phone:': '司机电话：',
  'Total fare': '总费用',
  'Confirm Trip': '确认行程',
  'PICKUP POINT': '上车点',
  'DROP DESTINATION': '下车地点',
  'DROP OFF': '下车',
  'GUESTS': '乘客',
  'BAGS': '行李',
  'DATE': '日期',
  'TIME': '时间',
  'Select your ride': '选择您的车辆',
  'Choose from our premium fleet.': '从我们的高端车队中选择。',
  'PICK UP': '上车',
  'Loading vehicles...': '正在加载车辆...',
  'Recommended': '推荐',
  'Booking summary': '预订摘要',
  'Booking Summary': '预订摘要',
  'Review your journey and fare.': '请核对行程和费用。',
  'PREMIUM SERIES': '高端系列',
  'Base fare': '基础费用',
  'GST (5%)': '消费税 (5%)',
  'Service fee': '服务费',
  'Grand total': '合计',
  'Online Payment': '在线支付',
  'UPI, Wallet, Netbanking': 'UPI、钱包、网上银行',
  'Cash to driver': '向司机付现金',
  'Cash': '现金',
  'Pay after trip ends': '行程结束后付款',
  'Pay directly to driver after trip ends.': '行程结束后直接向司机付款。',
  'Payment method': '支付方式',
  'Wallet': '钱包',
  'Manage payment methods': '管理支付方式',
  'CARD HOLDER': '持卡人',
  'EXPIRES': '有效期',
  'Add Payment Method': '添加支付方式',
  'Processing...': '处理中...',
  'Delete card': '删除卡片',
  'UPI': 'UPI',
  'Guest verification': '住客验证',
  'Mobile number': '手机号码',
  'Confirm OTP': '确认验证码',
  'OTP is not correct': '验证码不正确',
  'OTP has expired. Please request a new one.': '验证码已过期，请重新获取。',
  'This OTP has already been used. Please request a new one.': '此验证码已使用，请重新获取。',
  'Please wait before requesting another OTP.': '请稍后再请求新的验证码。',
  'Unable to resend OTP. Please try again.': '无法重新发送验证码，请重试。',
  'OTP sent again.': '验证码已重新发送。',
  'Please enter the complete 6-digit OTP': '请输入完整的 6 位验证码',
  'Please fill in your details to continue.': '请填写资料后继续。',
  'This username is already taken': '该用户名已被使用',
  'This email is already registered': '该邮箱已注册',
  'This account is not active. Please contact support.': '此账户未激活，请联系支持。',
  'Mobile number is required': '需要手机号码',
  'Resend OTP': '重新发送验证码',
  'Resend OTP in {time}': '{time} 后可重新发送',
  'Sending...': '发送中...',
  'Verify OTP': '验证验证码',
  'Verifying...': '正在验证...',
  'Full name': '姓名',
  'Username': '用户名',
  'Email': '邮箱',
  'Password': '密码',
  'Request Details': '请求详情',
  'Request submitted successfully !': '请求已成功提交！',
  'Finding you a driver at the earliest.': '我们正在尽快为您寻找司机。',
  'Request Submitted': '请求已提交',
  'Assigning a Driver': '正在分配司机',
  'Driver Assigned! Arriving in XX mins.': '司机已分配！预计 XX 分钟到达。',
  'Ride Completed!': '行程已完成！',
  'Cancel request': '取消请求',
  'Cancelling...': '正在取消...',
  'Expected Time': '预计时间',
  'Progress': '进度',
  'Current Status': '当前状态',
  'Track Driver >': '跟踪司机 >',
  'Help / Contact Us': '帮助 / 联系我们',
  'Cancel Request': '取消请求',
  'Ride cancelled': '行程已取消',
  'Ride completed': '行程已完成',
  'FINAL FARE': '最终费用',
  'Payment Pending': '待付款',
  'Charged successfully': '扣款成功',
  'Parking & Toll Charges': '停车与通行费',
  'Payment': '付款',
  'Amount to Pay': '应付金额',
  'From:': '从：',
  'To:': '到：',
  'Save card for future payments': '保存卡片以便下次付款',
  'Your payment is secured by Razorpay': '您的付款由 Razorpay 保护',
  'Saved Cards': '已保存的卡片',
  'Manage': '管理',
  'Loading saved cards...': '正在加载已保存的卡片...',
  'No saved cards': '没有已保存的卡片',
  'Add a card to make payments faster': '添加卡片以加快付款',
  'Are you sure you want to delete this card?': '确定要删除这张卡吗？',
  'Failed to delete card': '删除卡片失败',
  'Failed to add card': '添加卡片失败',
  'Please complete guest verification first.': '请先完成住客验证。',
  'Ride Details': '行程详情',
  'Route': '路线',
  'Pickup': '上车',
  'Drop-off': '下车',
  'Trip Details': '行程信息',
  'Distance': '距离',
  'Fare Range': '费用范围',
  'Timeline': '时间线',
  'Created': '创建时间',
  'Last Updated': '最后更新',
  'Vendor Information': '供应商信息',
  'Vendor Name:': '供应商名称：',
  'Vendor ID:': '供应商编号：',
  'Vehicle Information': '车辆信息',
  'Car Number:': '车牌号：',
  'Car ID:': '车辆编号：',
  'Driver Information': '司机信息',
  'Driver Name:': '司机姓名：',
  'Driver ID:': '司机编号：',
  'Customer Information': '客户信息',
  'Customer Name:': '客户姓名：',
  'Customer ID:': '客户编号：',
  'Your private fleet': '您的专属车队',
  'Identifying your stay...': '正在识别您的入住信息...',
  'Scanning your nearby hotels...': '正在查找附近的酒店...',
  'Map View': '地图',
  'PIN FOR THIS TRIP': '本次行程验证码',
  'PICK-UP SPOT': '上车地点',
  'MESSAGE': '消息',
  'CALL': '呼叫',
  'Connecting you with a driver': '正在为您连接司机',
  'Booking Confirmed!': '预订已确认！',
  'Connecting to chat...': '正在连接聊天...',
  'No messages yet. Start the conversation!': '还没有消息。开始对话吧！'
};

const es = {
  'Get started': 'Empezar',
  'Your premium travel experience.': 'Tu experiencia de viaje premium.',
  'Location access': 'Acceso a la ubicación',
  'We need your location to identify your hotel and find the nearest pickup point.': 'Necesitamos tu ubicación para identificar tu hotel y encontrar el punto de recogida más cercano.',
  'Allow access': 'Permitir acceso',
  'Finding nearby hotels...': 'Buscando hoteles cercanos...',
  'Retry': 'Reintentar',
  'Pick on map': 'Elegir en el mapa',
  'Search hotels': 'Buscar hoteles',
  'No vehicles available for this trip': 'No hay vehículos disponibles para este viaje',
  'Unable to load vehicles. Please try again.': 'No se pudieron cargar los vehículos. Inténtalo de nuevo.',
  'Select a hotel on the map': 'Elige un hotel en el mapa',
  'Staying at': 'Te hospedas en',
  'Edit': 'Editar',
  'Pickup point': 'Punto de recogida',
  'Hotel Porch': 'Entrada del hotel',
  'Confirm Location': 'Confirmar ubicación',
  'No hotel data is available right now.': 'No hay datos del hotel en este momento.',
  'No hotels were found near this location. You can try again or choose your hotel on the map.': 'No se encontraron hoteles cerca de esta ubicación. Inténtalo de nuevo o elige el hotel en el mapa.',
  'We could not load nearby hotels. Check your connection and tap Retry.': 'No se pudieron cargar los hoteles cercanos. Revisa tu conexión e inténtalo de nuevo.',
  'We need your location before nearby hotels can be shown.': 'Necesitamos tu ubicación para mostrar los hoteles cercanos.',
  'Selected Address': 'Dirección seleccionada',
  'Book Premium Rides for now or later.': 'Reserva viajes premium para ahora o más tarde.',
  'Hi {name}!': 'Hola, {name}!',
  'Where would you like to go today?': '¿A dónde te gustaría ir hoy?',
  'Search New Delhi...': 'Buscar Nueva Delhi...',
  'No results found': 'No se encontraron resultados',
  'Loading categories...': 'Cargando categorías...',
  'Loading locations...': 'Cargando lugares...',
  'No locations available. Please select a category.': 'No hay lugares disponibles. Elige una categoría.',
  'Home': 'Inicio',
  'Ride': 'Viaje',
  'Contact': 'Contacto',
  'Profile': 'Perfil',
  'All': 'Todos',
  'more': 'más',
  'less': 'menos',
  'List view': 'Vista de lista',
  'Grid view': 'Vista de cuadrícula',
  'Payment Methods': 'Métodos de pago',
  'Settings': 'Ajustes',
  'Logout': 'Cerrar sesión',
  'Close': 'Cerrar',
  'Install Moviq': 'Instalar Moviq',
  'Add Moviq to your home screen for quicker booking.': 'Añade Moviq a tu pantalla de inicio para reservar más rápido.',
  'Install': 'Instalar',
  'Not now': 'Ahora no',
  'On iPhone, tap Share, then Add to Home Screen.': 'En iPhone, toca Compartir y luego Añadir a pantalla de inicio.',
  'Got it': 'Entendido',
  'Open the browser menu and tap Install app.': 'Abre el menú del navegador y toca Instalar app.',
  'Follow these steps in Safari:': 'Sigue estos pasos en Safari:',
  'Open this page in Safari, then follow these steps:': 'Abre esta página en Safari y sigue estos pasos:',
  'Tap the Share button in Safari.': 'Toca el botón Compartir en Safari.',
  'Tap Add to Home Screen.': 'Toca Añadir a pantalla de inicio.',
  'Tap Add.': 'Toca Añadir.',
  'Are you sure you want to logout?': '¿Seguro que quieres cerrar sesión?',
  'Room {room} • {hotel}': 'Habitación {room} • {hotel}',
  'Edit Profile': 'Editar perfil',
  'Save': 'Guardar',
  'Back': 'Atrás',
  'Full Name': 'Nombre completo',
  'Email Address': 'Correo electrónico',
  'Phone Number': 'Teléfono',
  'Enter your name': 'Ingresa tu nombre',
  'Enter your email': 'Ingresa tu correo',
  'Enter your phone': 'Ingresa tu teléfono',
  'Profile updated successfully!': '¡Perfil actualizado!',
  'Profile image updated successfully!': '¡Foto de perfil actualizada!',
  'App preferences & legal': 'Preferencias de la app e información legal',
  'Go back': 'Volver',
  'Notifications': 'Notificaciones',
  'Location Access': 'Acceso a la ubicación',
  'Language': 'Idioma',
  'Dark Mode': 'Modo oscuro',
  'Privacy Policy': 'Política de privacidad',
  'Terms of Service': 'Términos del servicio',
  'About Moviq': 'Acerca de Moviq',
  'Made with ❤ for Travellers': 'Hecho con ❤ para viajeros',
  'English': 'English',
  'Hindi': 'हिंदी',
  'Chinese': '中文',
  'Spanish': 'Español',
  'Contact Us': 'Contáctanos',
  'moviq Support': 'Soporte moviq',
  'Priority Support': 'Soporte prioritario',
  'FAQs': 'Preguntas frecuentes',
  'Answer': 'Respuesta',
  'Questions': 'Preguntas',
  'History': 'Historial',
  'No matching questions.': 'No hay preguntas que coincidan.',
  'No FAQs yet.': 'Aún no hay preguntas.',
  'No answer is available for this question.': 'No hay respuesta para esta pregunta.',
  'CALL SUPPORT': 'LLAMAR A SOPORTE',
  'Previous FAQs': 'Preguntas anteriores',
  'Loading...': 'Cargando...',
  'Sign in to see your FAQ history.': 'Inicia sesión para ver tu historial de preguntas.',
  'No previous FAQs': 'No hay preguntas anteriores',
  'Open': 'Abierta',
  'In progress': 'En progreso',
  'Closed': 'Cerrada',
  'Questions and your previous help answers.': 'Preguntas y tus respuestas de ayuda anteriores.',
  'Search questions': 'Buscar preguntas',
  'Loading questions...': 'Cargando preguntas...',
  'Loading history...': 'Cargando historial...',
  'Loading answer...': 'Cargando respuesta...',
  'Back to FAQs': 'Volver a las preguntas',
  'Sign in to save this in your help history.': 'Inicia sesión para guardar esto en tu historial de ayuda.',
  'Today': 'Hoy',
  'Yesterday': 'Ayer',
  'This week': 'Esta semana',
  'Day': 'Día',
  'Month': 'Mes',
  'Year': 'Año',
  'No FAQs today': 'No hay preguntas hoy',
  'No FAQs yesterday': 'No hay preguntas de ayer',
  'No FAQs this week': 'No hay preguntas esta semana',
  'No FAQs this day': 'No hay preguntas este día',
  'No FAQs this month': 'No hay preguntas este mes',
  'No FAQs': 'No hay preguntas',
  'Rides': 'Viajes',
  'Review your journey so far.': 'Revisa tus viajes hasta ahora.',
  'Loading rides...': 'Cargando viajes...',
  'No rides found': 'No se encontraron viajes',
  'Waiting for payment': 'Esperando pago',
  'Upcoming': 'Próximos',
  'Past rides': 'Viajes anteriores',
  'Cancelled': 'Cancelados',
  'Vendor will be assigned': 'Se asignará un proveedor',
  'Waiting for vendor': 'Esperando proveedor',
  'Waiting for car': 'Esperando coche',
  'Car assigned': 'Coche asignado',
  'Vendor assigned': 'Proveedor asignado',
  'Requested vehicle': 'Vehículo solicitado',
  'Requested: {name}': 'Solicitado: {name}',
  'Pay now': 'Pagar ahora',
  'No rides waiting for payment': 'No hay viajes pendientes de pago',
  'No upcoming rides': 'No hay viajes próximos',
  'No past rides': 'No hay viajes anteriores',
  'No cancelled rides': 'No hay viajes cancelados',
  'Your ride history will appear here': 'Tu historial de viajes aparecerá aquí',
  'Driver phone:': 'Teléfono del conductor:',
  'Total fare': 'Tarifa total',
  'Confirm Trip': 'Confirmar viaje',
  'PICKUP POINT': 'PUNTO DE RECOGIDA',
  'DROP DESTINATION': 'DESTINO',
  'DROP OFF': 'LLEGADA',
  'GUESTS': 'PASAJEROS',
  'BAGS': 'MALETAS',
  'DATE': 'FECHA',
  'TIME': 'HORA',
  'Select your ride': 'Elige tu vehículo',
  'Choose from our premium fleet.': 'Elige de nuestra flota premium.',
  'PICK UP': 'RECOGIDA',
  'Loading vehicles...': 'Cargando vehículos...',
  'Recommended': 'Recomendado',
  'Booking summary': 'Resumen de la reserva',
  'Booking Summary': 'Resumen de la reserva',
  'Review your journey and fare.': 'Revisa tu viaje y la tarifa.',
  'PREMIUM SERIES': 'SERIE PREMIUM',
  'Base fare': 'Tarifa base',
  'GST (5%)': 'GST (5%)',
  'Service fee': 'Cargo por servicio',
  'Grand total': 'Total',
  'Online Payment': 'Pago en línea',
  'UPI, Wallet, Netbanking': 'UPI, billetera, banca en línea',
  'Cash to driver': 'Efectivo al conductor',
  'Cash': 'Efectivo',
  'Pay after trip ends': 'Paga al terminar el viaje',
  'Pay directly to driver after trip ends.': 'Paga directamente al conductor al terminar el viaje.',
  'Payment method': 'Método de pago',
  'Wallet': 'Billetera',
  'Manage payment methods': 'Administrar métodos de pago',
  'CARD HOLDER': 'TITULAR',
  'EXPIRES': 'VENCE',
  'Add Payment Method': 'Agregar método de pago',
  'Processing...': 'Procesando...',
  'Delete card': 'Eliminar tarjeta',
  'UPI': 'UPI',
  'Guest verification': 'Verificación del huésped',
  'Mobile number': 'Número de móvil',
  'Confirm OTP': 'Confirmar OTP',
  'OTP is not correct': 'El OTP no es correcto',
  'OTP has expired. Please request a new one.': 'El OTP ha caducado. Solicita uno nuevo.',
  'This OTP has already been used. Please request a new one.': 'Este OTP ya se usó. Solicita uno nuevo.',
  'Please wait before requesting another OTP.': 'Espera antes de pedir otro OTP.',
  'Unable to resend OTP. Please try again.': 'No se pudo reenviar el OTP. Inténtalo de nuevo.',
  'OTP sent again.': 'OTP enviado de nuevo.',
  'Please enter the complete 6-digit OTP': 'Ingresa el OTP completo de 6 dígitos',
  'Please fill in your details to continue.': 'Completa tus datos para continuar.',
  'This username is already taken': 'Este usuario ya está en uso',
  'This email is already registered': 'Este correo ya está registrado',
  'This account is not active. Please contact support.': 'Esta cuenta no está activa. Contacta a soporte.',
  'Mobile number is required': 'El número de móvil es obligatorio',
  'Resend OTP': 'Reenviar OTP',
  'Resend OTP in {time}': 'Reenviar OTP en {time}',
  'Sending...': 'Enviando...',
  'Verify OTP': 'Verificar OTP',
  'Verifying...': 'Verificando...',
  'Full name': 'Nombre completo',
  'Username': 'Usuario',
  'Email': 'Correo',
  'Password': 'Contraseña',
  'Request Details': 'Detalles de la solicitud',
  'Request submitted successfully !': '¡Solicitud enviada correctamente!',
  'Finding you a driver at the earliest.': 'Estamos buscando un conductor lo antes posible.',
  'Request Submitted': 'Solicitud enviada',
  'Assigning a Driver': 'Asignando un conductor',
  'Driver Assigned! Arriving in XX mins.': '¡Conductor asignado! Llegada en XX min.',
  'Ride Completed!': '¡Viaje completado!',
  'Cancel request': 'Cancelar solicitud',
  'Cancelling...': 'Cancelando...',
  'Expected Time': 'Hora prevista',
  'Progress': 'Progreso',
  'Current Status': 'Estado actual',
  'Track Driver >': 'Seguir al conductor >',
  'Help / Contact Us': 'Ayuda / Contáctanos',
  'Cancel Request': 'Cancelar solicitud',
  'Ride cancelled': 'Viaje cancelado',
  'Ride completed': 'Viaje completado',
  'FINAL FARE': 'TARIFA FINAL',
  'Payment Pending': 'Pago pendiente',
  'Charged successfully': 'Cobro realizado',
  'Parking & Toll Charges': 'Estacionamiento y peajes',
  'Payment': 'Pago',
  'Amount to Pay': 'Importe a pagar',
  'From:': 'Desde:',
  'To:': 'Hasta:',
  'Save card for future payments': 'Guardar la tarjeta para próximos pagos',
  'Your payment is secured by Razorpay': 'Tu pago está protegido por Razorpay',
  'Saved Cards': 'Tarjetas guardadas',
  'Manage': 'Gestionar',
  'Loading saved cards...': 'Cargando tarjetas guardadas...',
  'No saved cards': 'No hay tarjetas guardadas',
  'Add a card to make payments faster': 'Agrega una tarjeta para pagar más rápido',
  'Are you sure you want to delete this card?': '¿Seguro que quieres eliminar esta tarjeta?',
  'Failed to delete card': 'No se pudo eliminar la tarjeta',
  'Failed to add card': 'No se pudo agregar la tarjeta',
  'Please complete guest verification first.': 'Completa primero la verificación del huésped.',
  'Ride Details': 'Detalles del viaje',
  'Route': 'Ruta',
  'Pickup': 'Recogida',
  'Drop-off': 'Destino',
  'Trip Details': 'Detalles del viaje',
  'Distance': 'Distancia',
  'Fare Range': 'Rango de tarifa',
  'Timeline': 'Línea de tiempo',
  'Created': 'Creado',
  'Last Updated': 'Última actualización',
  'Vendor Information': 'Información del proveedor',
  'Vendor Name:': 'Nombre del proveedor:',
  'Vendor ID:': 'ID del proveedor:',
  'Vehicle Information': 'Información del vehículo',
  'Car Number:': 'Número del auto:',
  'Car ID:': 'ID del auto:',
  'Driver Information': 'Información del conductor',
  'Driver Name:': 'Nombre del conductor:',
  'Driver ID:': 'ID del conductor:',
  'Customer Information': 'Información del cliente',
  'Customer Name:': 'Nombre del cliente:',
  'Customer ID:': 'ID del cliente:',
  'Your private fleet': 'Tu flota privada',
  'Identifying your stay...': 'Identificando tu estadía...',
  'Scanning your nearby hotels...': 'Buscando hoteles cercanos...',
  'Map View': 'Mapa',
  'PIN FOR THIS TRIP': 'PIN DE ESTE VIAJE',
  'PICK-UP SPOT': 'PUNTO DE RECOGIDA',
  'MESSAGE': 'MENSAJE',
  'CALL': 'LLAMAR',
  'Connecting you with a driver': 'Conectándote con un conductor',
  'Booking Confirmed!': '¡Reserva confirmada!',
  'Connecting to chat...': 'Conectando al chat...',
  'No messages yet. Start the conversation!': 'Aún no hay mensajes. ¡Empieza la conversación!'
};

const translations = { hi, zh, es };

export const localeFor = (language) => {
  if (language === 'hi') return 'hi-IN';
  if (language === 'zh') return 'zh-CN';
  if (language === 'es') return 'es-ES';
  return 'en-GB';
};

export function translate(language, key, vars) {
  const table = translations[language];
  let text = (table && table[key]) || key;
  if (vars) {
    Object.keys(vars).forEach((name) => {
      text = text.split(`{${name}}`).join(String(vars[name] ?? ''));
    });
  }
  return text;
}
